import { gql } from '@apollo/client/core'
import { useMutation } from '@vue/apollo-composable'
import { IRefreshTokenResponse } from '@types'

const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      type
      payload {
        ... on LoginResponse {
          refreshToken
          accessToken
        }
      }
    }
  }
`

/**
 * Hook para a mutação de refresh token.
 * @returns A mutação de refresh token.
 */
export const useRefreshTokenMutation = () => {
  const mutation = useMutation<IRefreshTokenResponse>(REFRESH_TOKEN_MUTATION)
  return mutation
}
